import VueCookie from 'vue-cookie'
import HTTP from '@/apps/axiosConfig'

export const actions = {
  signOut: (store, payload) => {
    HTTP.delete(`/${payload.type}_auth/sign_out`, {
      headers: store.state[`${payload.type}Auth`]
    }).then(() => {
      store.dispatch('resetStore', payload.type)

      VueCookie.delete(`${payload.type}_session`)
      payload.router.push({ name: `${payload.type}SignIn` })
    })
  },
  resetStore: (store, type) => {
    let upType = type.toUpperCase()
    store.commit(`SET_CURRENT_${upType}`, null)
    store.commit(`SET_${upType}_AUTH`, {})
    store.commit(`SET_${upType}_LOADED`, false)
    if (type === 'client') {
      store.commit('SET_PRODUCT_REGISTRATIONS', [])
      store.commit('SET_PR_FORM_INFOS', {})
    }
    if (type === 'user') {
      store.commit('SET_DOCUMENTS', [])
      store.commit('SET_INTERVENTIONS', {})
    }
  },
  setNotification: ({ commit }, payload) => {
    let timeout = typeof (payload.expiration) === 'undefined' ? 5000 : payload.expiration
    commit('SET_NOTIFICATION', {
      message: payload.message,
      mode: payload.mode
    })
    if (timeout > 0) {
      window.setTimeout(() => {
        commit('SET_NOTIFICATION', {
          message: null,
          mode: 'success'
        })
      }, timeout)
    }
  },
  getCurrentSession (store, type) {
    store.commit('SET_API_ERROR', false)

    let upType = type.toUpperCase()
    store.commit(`SET_${upType}_LOADED`, false)

    let session = VueCookie.get(`${type}_session`)
    if (session) {
      const currentSession = JSON.parse(session)

      return HTTP.get(`/${type}_auth/validate_token`, {
        headers: currentSession.tokens
      }).then(resp => {
        store.commit(`SET_CURRENT_${upType}`, { ...resp.data.data, type: type })
        store.commit(`SET_${upType}_AUTH`, currentSession.tokens)
        store.commit(`SET_${upType}_LOADED`, true)

        // return check existing session
        return true
      }).catch(() => false)
    } else {
      return false
    }
  },

  // ===========================
  // == Fetch data for Client

  async fetchCounts ({ commit, state }) {
    await HTTP.get('/clients/' + state.currentClient.id + '/counts', {
      headers: state.clientAuth
    }).then(resp => {
      commit('SET_COUNTS', resp.data)
    })
  },
  async firstFetchPR ({ dispatch, state }) {
    if (!_.isEmpty(state.currentClient) && _.isEmpty(state.productRegistrations)) {
      await dispatch('fetchProductRegistrations')
    }
    return _.isEmpty(state.productRegistrations)
  },
  async fetchProductRegistrations ({ dispatch, commit, state }) {
    commit('SET_LOADING_REQUEST', true)
    await HTTP.get('/clients/' + state.currentClient.id + '/product_registrations', {
      headers: state.clientAuth
    }).then(resp => {
      commit('SET_PRODUCT_REGISTRATIONS', resp.data)
      commit('SET_LOADING_REQUEST', false)
    })
    await dispatch('fetchCounts')
  },
  async fetchPrFormInfos ({ commit, state }) {
    if (!_.isEmpty(state.currentClient) && _.isEmpty(state.prFormInfos)) {
      await HTTP.get('/clients/' + state.currentClient.id + '/product_registrations/form_informations', {
        headers: state.clientAuth
      }).then(resp => {
        commit('SET_PR_FORM_INFOS', resp.data)
      })
    }
  },
  async firstFetchReviews ({ dispatch, state }) {
    if (!_.isEmpty(state.currentClient) && _.isEmpty(state.reviews)) {
      await dispatch('fetchReviews')
    }
  },
  async fetchReviews ({ commit, state }) {
    await HTTP.get('/clients/' + state.currentClient.id + '/reviews', {
      headers: state.clientAuth
    }).then(resp => {
      commit('SET_REVIEWS', resp.data)
    })
  },

  // ===========================
  // == Fetch data for User

  async fetchDocuments ({ commit, state }) {
    if (!_.isEmpty(state.currentUser) && _.isEmpty(state.documents)) {
      await HTTP.get('/users/' + state.currentUser.id + '/folders', {
        headers: state.userAuth
      }).then(resp => {
        commit('SET_DOCUMENTS', resp.data)
      })
    }
  },
  async firstFetchInter ({ dispatch, state }) {
    if (!_.isEmpty(state.currentUser) && _.isEmpty(state.interventions)) {
      await dispatch('fetchInterventions')
    }
  },
  async fetchInterventions ({ commit, state }) {
    await HTTP.get('/users/' + state.currentUser.id + '/interventions', {
      headers: state.userAuth
    }).then(resp => {
      commit('SET_INTERVENTIONS', resp.data)
    })
  },
  async fetchTrainings ({ commit, state }) {
    await HTTP.get('/users/' + state.currentUser.id + '/training_sessions', {
      headers: state.userAuth
    }).then(resp => {
      commit('SET_TRAININGS', resp.data)
    })
  }
}
